import type {
  FaultyData,
  FormField,
  FormValues,
  TicketDetail,
} from '../../../../types/auditFormTypes';

export const defaultTicket: Pick<TicketDetail, 'game' | 'name' | 'pack' | 'range'> = {
  game: '',
  name: '',
  pack: '',
  range: '',
};

export const createEmptyTicketDetail = (): TicketDetail => ({
  game: '',
  pack: '',
  range: '',
  name: '',
  isMissing: false,
  userAccepted: false,
  haveError: false,
  errorMessage: '',
  rangeMismatch: false,
  rangeAccepted: false,
  rangeTooltip: '',
  newValues: {},
  newField: true,
});

export const createAuditDynamicFormDefaultValues = (formData: FormValues | any) => {
  return formData || {
    action: 'finalize',
    confidence_score: 0,
    notes: '',
    shift_date: '',
    shift_start_time: '',
    shift_end_time: '',
    retailer_id: '',
    ticket_details: [defaultTicket],
  };
};

export const buildSyncedTicketDetails = (
  fields: FormField[],
  ticketDetails: TicketDetail[],
) => {
  return fields.map((_, index) => {
    const existingTicket = ticketDetails[index];

    if (existingTicket) {
      return { ...existingTicket };
    }

    return createEmptyTicketDetail();
  });
};

export const buildJsonModeFormData = (currentFormValues: FormValues | any) => {
  return {
    ...currentFormValues,
    ticket_details:
      currentFormValues.ticket_details?.map((formTicket: any) => {
        return {
          ...formTicket,
        };
      }) || [],
  };
};

export const buildAuditDynamicFormErrorState = (
  errors: any,
  currentValues: FormValues | any,
) => {
  const faultyData: FaultyData = {};

  const getValueByPath = (obj: any, path: string) => {
    const parts = path.split('.');
    let value = obj;

    for (const part of parts) {
      if (value && typeof value === 'object') {
        value = value[part];
      } else {
        return undefined;
      }
    }

    return value;
  };

  const processErrors = (currentErrors: any, prefix = '') => {
    if (!currentErrors) {
      return;
    }

    Object.keys(currentErrors).forEach((key) => {
      const error = currentErrors[key];
      const fullPath = prefix ? `${prefix}.${key}` : key;

      if (error?.message) {
        const value = getValueByPath(currentValues, fullPath);

        if (!faultyData[fullPath]) {
          faultyData[fullPath] = {
            error: error.message,
            value,
          };
        }
        return;
      }

      if (typeof error === 'object' && error !== null) {
        processErrors(error, fullPath);
      }
    });
  };

  processErrors(errors);

  return {
    errorMessage: JSON.stringify(errors, null, 2),
    faultyData,
  };
};
